module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "row hidden-print"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title title-transfer"
  }, [_vm._v("Transferir crédito")]), _vm._v(" "), _c('div', {
    staticClass: "box-balance"
  }, [_vm._v("\n        Saldo Disponível:\n        "), (_vm.contractData) ? _c('b', {
    staticClass: "balance-plus"
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.contractData.currentBalance.currentTotalBalance)))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "content hidden-print"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('ul', {
    staticClass: "wizard ad margin-b20"
  }, [_c('li', {
    class: {
      active: _vm.step == 1, past: _vm.step > 1
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.step == 2, past: _vm.step > 2
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.step == 3, past: _vm.step > 3
    }
  }, [_vm._m(4), _vm._v(" "), _vm._m(5)])])])]), _vm._v(" "), (_vm.step == 1) ? [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "searchStep1"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "search-box",
    class: {
      found: _vm.status == 'FOUND'
    }
  }, [_c('h1', {
    staticClass: "bold text-center margin-b20"
  }, [_vm._v("\n              Informe o CNPJ do Favorecido:\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.search),
      expression: "search",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|cnpj'),
      expression: "'required|cnpj'"
    }, {
      name: "mask-cnpj",
      rawName: "v-mask-cnpj"
    }],
    staticClass: "form-control search text-center bold",
    attrs: {
      "type": "tel",
      "inputmode": "numeric",
      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2})$",
      "name": "taxIdNumber",
      "data-vv-validate-on": "blur",
      "placeholder": "Digite o CNPJ",
      "maxlength": "18",
      "autofocus": "",
      "novalidate": "",
      "formnovalidate": ""
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "change": function($event) {
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-purple",
    attrs: {
      "type": "button",
      "name": "button",
      "id": "cnpjSearch"
    },
    on: {
      "click": function($event) {
        return _vm.filter()
      }
    }
  }, [_c('i', {
    staticClass: "icon-search"
  })]), _vm._v(" "), (_vm.status == 'ERROR') ? _c('div', {
    staticClass: "alert alert-warning margin-t20 text-center",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("CNPJ não encontrado ou inválido!")]), _vm._v(" Faça uma nova\n              busca.\n            ")]) : _vm._e()])])]), _vm._v(" "), (_vm.status == 'FOUND' && _vm.contracts && _vm.contracts.length > 0) ? _c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "origin-info"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.userReceive.taxIdNumber)))]), _vm._v(" "), _c('span', [_vm._v(" - " + _vm._s(_vm.userReceive.companyName))])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-flat"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "8%"
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Contrato")]), _vm._v(" "), _c('th', [_vm._v("Razão Social")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Nome Fantasia")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Plano")]), _vm._v(" "), (_vm.checkBalance) ? _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("\n                    Saldo\n                  ")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.contracts), function(c, index) {
    return _c('tr', {
      key: c.contractId
    }, [_c('td', [_c('div', {
      staticClass: "radio-blue category",
      class: c.contractId
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contractCred),
        expression: "contractCred"
      }],
      key: index,
      staticClass: "radiobtn",
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": c,
        "checked": _vm._q(_vm.contractCred, c)
      },
      on: {
        "change": function($event) {
          _vm.contractCred = c
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "radio-label",
      attrs: {
        "for": index
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "check"
    })])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(c.contractId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(c.companyName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(c.companyTradeName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(c.planName))]), _vm._v(" "), (_vm.checkBalance) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v("\n                    " + _vm._s(_vm._f("cents")(c.currentBalance)) + "\n                  ")]) : _vm._e()])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(" ")]), _vm._v(" "), (_vm.checkBalance) ? _c('td', [_vm._v(" ")]) : _vm._e()])])]), _vm._v(" "), _c('ul', {
    staticClass: "transfer-data-box"
  }, [_vm._m(6), _vm._v(" "), _vm._l((_vm.contracts), function(c, index) {
    return _c('li', {
      key: c.contractId
    }, [_c('div', {
      staticClass: "radio-blue category",
      class: c.contractId
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contractCred),
        expression: "contractCred"
      }],
      staticClass: "radiobtn",
      attrs: {
        "type": "radio",
        "name": "contractCred",
        "id": index
      },
      domProps: {
        "value": c,
        "checked": _vm._q(_vm.contractCred, c)
      },
      on: {
        "change": function($event) {
          _vm.contractCred = c
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "radio-label",
      attrs: {
        "for": index
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "check"
    })]), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v(_vm._s(c.contractId))]), _vm._v(" "), _c('p', {
      staticClass: "three-dots"
    }, [_vm._v(_vm._s(c.companyName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(c.planName))])])])
  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-buttons-box",
    class: {
      'text-center': _vm.status != 'FOUND'
    }
  }, [_c('router-link', {
    staticClass: "btn btn-danger",
    class: {
      found: _vm.status == 'FOUND'
    },
    attrs: {
      "to": {
        name: 'plans'
      },
      "tag": "button",
      "data-toggle": "tooltip",
      "title": "Cancelar"
    }
  }, [_vm._v("\n          Cancelar\n        ")]), _vm._v(" "), (_vm.status == 'FOUND') ? _c('button', {
    staticClass: "btn btn-primary add",
    class: {
      disabled: !_vm.contractCred
    },
    attrs: {
      "id": "advanceStep2",
      "disabled": !_vm.contractCred
    },
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("\n          Avançar\n          "), _c('i', {
    staticClass: "icon-circle-right"
  })]) : _vm._e()], 1)] : _vm._e(), _vm._v(" "), (_vm.step == 2) ? [_c('div', {
    attrs: {
      "id": "step2"
    }
  }, [_c('div', {
    staticClass: "margin-20"
  }, [_c('div', {
    staticClass: "row margin-b20"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('transfer-shipper-value', {
    attrs: {
      "favored": _vm.favored,
      "balance": _vm.contractData.currentBalance.currentTotalBalance
    },
    model: {
      value: (_vm.transfValue),
      callback: function($$v) {
        _vm.transfValue = $$v
      },
      expression: "transfValue"
    }
  }), _vm._v(" "), (_vm.checkTransferValue) ? _c('div', {
    staticClass: "alert alert-warning margin-t20 text-center",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n                Valor acima do saldo disponível.\n              ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "back-button-box"
  }, [_c('button', {
    staticClass: "btn no-btn",
    attrs: {
      "id": "backStep1"
    },
    on: {
      "click": function($event) {
        _vm.step = _vm.step - 1
      }
    }
  }, [_vm._v("\n              Voltar\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "action-buttons-box"
  }, [_c('router-link', {
    staticClass: "btn btn-danger found",
    attrs: {
      "to": {
        name: 'plans'
      },
      "tag": "button",
      "data-toggle": "tooltip",
      "title": "Cancelar"
    }
  }, [_vm._v("\n              Cancelar\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary add",
    class: {
      disabled: _vm.checkValue || _vm.checkTransferValue
    },
    attrs: {
      "disabled": _vm.checkValue || _vm.checkTransferValue,
      "id": "advanceStep3"
    },
    on: {
      "click": function($event) {
        _vm.step = _vm.step + 1
      }
    }
  }, [_vm._v("\n              Avançar\n              "), _c('i', {
    staticClass: "icon-circle-right"
  })])], 1)])])] : _vm._e(), _vm._v(" "), (_vm.step == 3) ? [_c('div', {
    attrs: {
      "id": "step3"
    }
  }, [_c('ul', {
    staticClass: "transfer-summary"
  }, [_c('li', [_vm._v("\n            Favorecido\n            "), _c('span', [_vm._v(_vm._s(_vm.userReceive.companyName))])]), _vm._v(" "), _c('li', [_vm._v("\n            CNPJ\n            "), _c('span', [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.userReceive.taxIdNumber)))])]), _vm._v(" "), _c('li', [_vm._v("\n            Contrato\n            "), _c('span', [_vm._v(_vm._s(_vm.contractCred.contractId))])]), _vm._v(" "), _c('li', [_vm._v("\n            Plano\n            "), _c('span', [_vm._v(_vm._s(_vm.contractCred.planName))])]), _vm._v(" "), _c('li', [_vm._v("\n            Valor da transferência\n            "), _c('span', [_vm._v("R$ " + _vm._s(_vm._f("cents")(_vm.fomatedValue)))])]), _vm._v(" "), _c('li', [_vm._v("\n            Taxa da transferência\n            "), _c('span', [_vm._v("R$ " + _vm._s(_vm._f("cents")(_vm.fomatedTax)))])]), _vm._v(" "), _c('li', [_vm._v("\n            Total da transferência\n            "), _c('span', [_vm._v("R$ " + _vm._s(_vm._f("cents")(_vm.fomatedTotal)))])])]), _vm._v(" "), _c('div', {
    staticClass: "transfer-summary-mob"
  }, [_c('p', [_vm._v("FAVORECIDO")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.userReceive.taxIdNumber)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.userReceive.companyName))]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n              Contrato\n              "), _c('span', [_vm._v(_vm._s(_vm.contractCred.contractId))])]), _vm._v(" "), _c('li', [_vm._v("\n              Plano\n              "), _c('span', [_vm._v(_vm._s(_vm.contractCred.planName))])]), _vm._v(" "), _c('li', [_vm._v("\n              Valor da transferência\n              "), _c('span', [_vm._v("R$ " + _vm._s(_vm._f("cents")(_vm.fomatedValue)))])]), _vm._v(" "), _c('li', [_vm._v("\n              Taxa da transferência\n              "), _c('span', [_vm._v("R$ " + _vm._s(_vm._f("cents")(_vm.fomatedTax)))])]), _vm._v(" "), _c('li', [_vm._v("\n              Total da transferência\n              "), _c('span', [_vm._v("R$ " + _vm._s(_vm._f("cents")(_vm.fomatedTotal)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 margin-b20"
  }, [(_vm.status == 'ERROR') ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.messageError) + "\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "back-button-box"
  }, [_c('button', {
    staticClass: "btn no-btn",
    attrs: {
      "id": "backStep3"
    },
    on: {
      "click": function($event) {
        _vm.step = _vm.step - 1
      }
    }
  }, [_vm._v("\n            Voltar\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "action-buttons-box"
  }, [_c('router-link', {
    staticClass: "btn btn-danger found",
    attrs: {
      "to": {
        name: 'plans'
      },
      "tag": "button",
      "data-toggle": "tooltip",
      "title": "Cancelar"
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary end",
    on: {
      "click": function($event) {
        return _vm.transfer()
      }
    }
  }, [_vm._v("\n            Transferir\n          ")])], 1)])] : _vm._e(), _vm._v(" "), (_vm.step == 4) ? [_c('div', {
    attrs: {
      "id": "step4"
    }
  }, [_c('h1', [_vm._v("Transferência realizada com sucesso!")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/Icon-check-circle.svg",
      "alt": "icon-check-circle"
    }
  }), _vm._v(" "), _c('div', {}, [_c('router-link', {
    staticClass: "btn btn-outline",
    attrs: {
      "to": {
        name: 'plans'
      },
      "tag": "button",
      "data-toggle": "tooltip",
      "title": "Voltar a meus planos"
    }
  }, [_vm._v("\n            OK\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-full",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModalReceipt = true;
        _vm.modalReceipt();
      }
    }
  }, [_vm._v("\n            Comprovante de transferência\n          ")])], 1)])] : _vm._e()], 2), _vm._v(" "), (_vm.showModalReceipt) ? _c('modal-receipt-transfer', {
    attrs: {
      "orderData": _vm.orderData
    },
    on: {
      "close": _vm.close
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-avatar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline"
  }, [_c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("Identificação do favorecido")]), _vm._v(" "), _c('small', [_vm._v("Identificação do favorecido")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-money-transfer"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline"
  }, [_c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("Valor da transferência")]), _vm._v(" "), _c('small', [_vm._v("Valor da transferência")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-confirmation-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline"
  }, [_c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("Resumo e confirmação")]), _vm._v(" "), _c('small', [_vm._v("Resumo e confirmação")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v(" ")]), _vm._v(" "), _c('p', [_vm._v("Contrato")]), _vm._v(" "), _c('p', [_vm._v("Razão Social")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-cb8e0b90!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/shipper/transfer-shipper.vue
// module id = 2215
// module chunks = 1